const url = '/crm-actions';
const Provider = 'CrmActions';
const dbModel = 'CrmActions';

export { url, Provider, dbModel };
